export const ALL_VALUE = "__ALL__";
export const EMPTY_STRING = "";
export const DOT = ".";
export const ZERO = "0";
export const SPACE = " ";
export const DASH_NULL_VALUE = "—";
